var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"6","height":"11","viewBox":"0 0 6 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 5.5L0.75 10.2631L0.75 0.73686L6 5.5Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }